/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { OrgNetworks } from '../model';
/**
 * SellerNetworkApi - axios parameter creator
 * @export
 */
export const SellerNetworkApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Networks the User is a member of, grouped by group by Organisation. These are only the Orgs that are marked as head networks.
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerBuyerOrgNetworkList: async (aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/seller/buyer_org/network`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SellerNetworkApi - functional programming interface
 * @export
 */
export const SellerNetworkApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SellerNetworkApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Networks the User is a member of, grouped by group by Organisation. These are only the Orgs that are marked as head networks.
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sellerBuyerOrgNetworkList(aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrgNetworks>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sellerBuyerOrgNetworkList(aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SellerNetworkApi - factory interface
 * @export
 */
export const SellerNetworkApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SellerNetworkApiFp(configuration)
    return {
        /**
         * 
         * @summary Networks the User is a member of, grouped by group by Organisation. These are only the Orgs that are marked as head networks.
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerBuyerOrgNetworkList(aaSource?: string, options?: any): AxiosPromise<Array<OrgNetworks>> {
            return localVarFp.sellerBuyerOrgNetworkList(aaSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for sellerBuyerOrgNetworkList operation in SellerNetworkApi.
 * @export
 * @interface SellerNetworkApiSellerBuyerOrgNetworkListRequest
 */
export interface SellerNetworkApiSellerBuyerOrgNetworkListRequest {
    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof SellerNetworkApiSellerBuyerOrgNetworkList
     */
    readonly aaSource?: string
}

/**
 * SellerNetworkApi - object-oriented interface
 * @export
 * @class SellerNetworkApi
 * @extends {BaseAPI}
 */
export class SellerNetworkApi extends BaseAPI {
    /**
     * 
     * @summary Networks the User is a member of, grouped by group by Organisation. These are only the Orgs that are marked as head networks.
     * @param {SellerNetworkApiSellerBuyerOrgNetworkListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerNetworkApi
     */
    public sellerBuyerOrgNetworkList(requestParameters: SellerNetworkApiSellerBuyerOrgNetworkListRequest = {}, options?: any) {
        return SellerNetworkApiFp(this.configuration).sellerBuyerOrgNetworkList(requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }
}
